import React, { useState } from "react";

const CouponForm = ({
    initialValues = {},
    onSubmit,
    loading = false,
}) => {

    const [formData, setFormData] = useState({
        code: initialValues.code || "",
        title: initialValues.title || "",
        description: initialValues.description || "",

        discountType: initialValues.discountType || "percentage",
        discountValue: initialValues.discountValue || "",

        maxDiscount: initialValues.maxDiscount || "",
        minOrderAmount: initialValues.minOrderAmount || "",

        usageLimit: initialValues.usageLimit || "",
        perUserLimit: initialValues.perUserLimit || "",

        validFrom: initialValues.validFrom
            ? initialValues.validFrom.slice(0, 16)
            : "",

        validUntil: initialValues.validUntil
            ? initialValues.validUntil.slice(0, 16)
            : "",

        status: initialValues.status || "active",

        customerType: initialValues.customerType || "all",

        firstOrderOnly:
            initialValues.firstOrderOnly || false,

        autoApply:
            initialValues.autoApply || false,
    });

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : value,
        }));
    };

    const handleSubmit = (e) => {

        e.preventDefault();

        if (!formData.code.trim()) {
            return alert("Coupon code is required");
        }

        if (!formData.title.trim()) {
            return alert("Coupon title is required");
        }

        if (!formData.discountValue) {
            return alert("Discount value is required");
        }

        if (!formData.validFrom) {
            return alert("Select Valid From");
        }

        if (!formData.validUntil) {
            return alert("Select Valid Until");
        }

        onSubmit(formData);
    };

    return (

        <form
            className="coupon-form"
            onSubmit={handleSubmit}
        >

            <div className="form-grid">

                <div className="form-group">
                    <label>Coupon Code</label>

                    <input
                        type="text"
                        name="code"
                        value={formData.code}
                        onChange={handleChange}
                        placeholder="HOME100"
                    />
                </div>

                <div className="form-group">
                    <label>Coupon Title</label>

                    <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group full-width">
                    <label>Description</label>

                    <textarea
                        rows="4"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label>Discount Type</label>

                    <select
                        name="discountType"
                        value={formData.discountType}
                        onChange={handleChange}
                    >
                        <option value="percentage">
                            Percentage
                        </option>

                        <option value="fixed">
                            Fixed Amount
                        </option>
                    </select>
                </div>

                <div className="form-group">
                    <label>Discount Value</label>

                    <input
                        type="number"
                        name="discountValue"
                        value={formData.discountValue}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label>Maximum Discount</label>

                    <input
                        type="number"
                        name="maxDiscount"
                        value={formData.maxDiscount}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label>Minimum Order</label>

                    <input
                        type="number"
                        name="minOrderAmount"
                        value={formData.minOrderAmount}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label>Usage Limit</label>

                    <input
                        type="number"
                        name="usageLimit"
                        value={formData.usageLimit}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label>Per User Limit</label>

                    <input
                        type="number"
                        name="perUserLimit"
                        value={formData.perUserLimit}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label>Valid From</label>

                    <input
                        type="datetime-local"
                        name="validFrom"
                        value={formData.validFrom}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label>Valid Until</label>

                    <input
                        type="datetime-local"
                        name="validUntil"
                        value={formData.validUntil}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label>Customer Type</label>

                    <select
                        name="customerType"
                        value={formData.customerType}
                        onChange={handleChange}
                    >
                        <option value="all">All Customers</option>
                        <option value="new">New Customers</option>
                        <option value="existing">Existing Customers</option>
                    </select>
                </div>

                <div className="form-group">
                    <label>Status</label>

                    <select
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                    >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                        <option value="scheduled">Scheduled</option>
                    </select>
                </div>

            </div>

            <div className="checkbox-group">

                <label>
                    <input
                        type="checkbox"
                        name="firstOrderOnly"
                        checked={formData.firstOrderOnly}
                        onChange={handleChange}
                    />

                    First Order Only
                </label>

                <label>
                    <input
                        type="checkbox"
                        name="autoApply"
                        checked={formData.autoApply}
                        onChange={handleChange}
                    />

                    Auto Apply Coupon
                </label>

            </div>

            <div className="form-actions">

                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                >
                    {loading
                        ? "Saving..."
                        : "Save Coupon"}
                </button>

            </div>

        </form>

    );
};

export default CouponForm;